import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import MercuryLogo from './MercuryLogo';
import { BOOKING_URL } from '../mock';

const links = [
  { label: 'Services', href: '#services' },
  { label: 'Who We Serve', href: '#who-we-serve' },
  { label: 'Process', href: '#how-it-works' },
  { label: 'Results', href: '#testimonials' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? 'backdrop-blur-lg bg-[#faf9f5]/85 border-b border-[#e8e4d8]' : ''}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <MercuryLogo />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-[#5a5f5c] hover:text-[#0b0f0d]">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:block">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="bg-[#0b0f0d] hover:bg-[#1a1f1c] text-white font-semibold text-sm px-5 py-2.5 rounded-full inline-flex items-center gap-2">
            Book a Free Call
          </a>
        </div>
        <button onClick={() => setOpen(!open)} className="lg:hidden text-[#0b0f0d]" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#faf9f5] border-t border-[#e8e4d8] px-6 py-6 space-y-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-[#5a5f5c] hover:text-[#0b0f0d]">
              {l.label}
            </a>
          ))}
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-[#0b0f0d] text-white font-semibold text-sm px-5 py-2.5 rounded-full">
            Book a Free Call
          </a>
        </div>
      )}
    </header>
  );
}
